import React from 'react';
import { KoSelect } from 'packages/select';
import styles from './activity.module.scss';
import KoIcon from '@kwapio/icons';
import KoInput from 'packages/input';

export default function KoActivityTypes({ value, onChange, disabled, defaultValue, options }) {
  return options ? (
    <KoSelect
      value={value}
      onChange={onChange}
      showSearch
      optionFilterProp="label"
      defaultValue={defaultValue}
      disabled={disabled}
      placeholder="Select activity type"
      options={options}
      optionRender={(option) => (
        <div className={styles.iconWithLabel} role="img" aria-label={option.data?.label}>
          <KoIcon name={option.data?.icon} />
          {option.data?.label}
        </div>
      )}
    />
  ) : (
    <KoInput disabled placeholder="Loading activity types..." />
  );
}
